import React__default from 'react';

const FallbackComponent = ({ error, resetErrorBoundary }) => {
    return (React__default.createElement("div", null,
        React__default.createElement("div", null,
            React__default.createElement("div", null,
                "ERROR: ",
                error?.message)),
        React__default.createElement("div", null,
            React__default.createElement("button", { onClick: resetErrorBoundary }, "RESET"))));
};

export { FallbackComponent as default };
//# sourceMappingURL=ErrorFallback.js.map
